"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.viewList = void 0;
exports.viewList = {
    path: "M2.91669 4.16667V15.8333H17.0834V4.16667H2.91669ZM6.25002 5.83333V7.5H4.58335V5.83333H6.25002ZM4.58335 9.16667V10.8333H6.25002V9.16667H4.58335ZM4.58335 12.5H6.25002V14.1667H4.58335V12.5ZM7.91669 14.1667H15.4167V12.5H7.91669V14.1667ZM15.4167 10.8333H7.91669V9.16667H15.4167V10.8333ZM7.91669 7.5H15.4167V5.83333H7.91669V7.5Z",
    originalWidth: 20,
    originalHeight: 20,
    basicColor: "tableGray1",
    activeColor: "tableBlack2"
};
